import { LeadModel } from "../models/lead.model";
import  { analyticsService, firebaseService } from "./firebase-service";

export class RegisterLeadService {
  async register(model: LeadModel) {
    if (!firebaseService.userUid) await firebaseService.signInAnonymouysly();
    const collectionName = "leads-participar-comunidade";
    const docRef = firebaseService.getDocRef(collectionName, firebaseService.userUid);
    await firebaseService.saveDoc(docRef, { ...model });
    analyticsService.event("add-leads-participar-comunidade", { id: docRef.id });
    firebaseService.signOutAnonymouysly();
    return docRef.id;
  }
}
